import { Pencil, ReceiptText, ScanBarcode } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { Legend } from "./Legend.tsx";

interface CaptureBarProps {
  readonly onAddManual: () => void;
  readonly onScanBarcode: () => void;
  readonly onScanReceipt: () => void;
}

export const CaptureBar: FC<CaptureBarProps> = ({
  onAddManual,
  onScanBarcode,
  onScanReceipt,
}) => (
  <div className="shrink-0 border-t bg-card">
    <div className="flex justify-center px-3.5 pt-[30px] pb-3">
      <div className="relative h-[58px] w-[268px]">
        <div className="absolute inset-0 flex items-center justify-between rounded-[29px] border bg-background px-6 shadow-sm">
          <button
            className="flex flex-col items-center gap-[3px] text-foreground"
            onClick={onScanReceipt}
            type="button"
          >
            <ReceiptText className="size-[21px]" />
            <span className="text-[10px] font-semibold text-muted-foreground">
              Receipt
            </span>
          </button>
          <button
            className="flex flex-col items-center gap-[3px] text-foreground"
            onClick={onAddManual}
            type="button"
          >
            <Pencil className="size-5" />
            <span className="text-[10px] font-semibold text-muted-foreground">
              Manual
            </span>
          </button>
        </div>
        <button
          aria-label="Scan a barcode"
          className={`
            absolute -top-[26px] left-1/2 flex size-[68px] -translate-x-1/2 items-center justify-center rounded-full border-4 border-card bg-primary text-primary-foreground shadow-md transition-transform
            active:scale-95
          `}
          onClick={onScanBarcode}
          type="button"
        >
          <ScanBarcode className="size-[30px]" />
        </button>
      </div>
    </div>
    <Legend />
  </div>
);
